import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopDevPageSide300x250Gak from './gak/DesktopDevPageSide300x250Atf';
import DesktopDevPageSide300x250Fs from './freestar/DesktopDevPageSide300x250Atf';
const DesktopDevPageSide300x250Atf = ({ safety ='off'  })=>{
    const isFreestar = useFlag('ads_freestar');
    if (isFreestar) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Fs, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Gak, {
        safety: safety
    });
};
DesktopDevPageSide300x250Atf.displayName = 'DesktopDevPageSide300x250Atf';
export default DesktopDevPageSide300x250Atf;
